module.exports = __webpack_public_path__ + "static/media/404.3b181eb7.svg";